import React, { useEffect, useState } from "react";
import AppBar from "./AppBar";
import MemberStrip from "./MemberStrip";
import { useMandate } from "./MandateContext";
import customFetch from "../apicall/api";
import { resolvePaymentVendorDetails } from "./mandateValidity";

const BLUE = "#0178B7";

function getInitialSelected(mapId) {
  if (mapId === null || mapId === undefined) {
    return null;
  }
  return mapId;
}

function vendorAbbr(code, name) {
  const c = (code || "").trim();
  if (c.length >= 2) return c.slice(0, 2).toUpperCase();
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "--";
  return parts.map((w) => w[0]).join("").toUpperCase().slice(0, 2);
}

function vendorUi(code, name) {
  const c = (code || "").toUpperCase();
  const n = (name || "").toUpperCase();
  if (c === "RAZORPAY" || c === "RP" || n.includes("RAZOR")) {
    return { color: "#2563eb", abbr: "Rp", selBg: "#eff6ff", selBorder: "#2563eb" };
  }
  if (c === "EB" || n.includes("EASE")) {
    return { color: "#7c3aed", abbr: "Eb", selBg: "#f5f3ff", selBorder: "#7c3aed" };
  }
  return { color: BLUE, abbr: "Pe", selBg: "#f5f0ff", selBorder: BLUE };
}

function mapPaymentVendors(details) {
  if (!Array.isArray(details) || !details.length) return [];
  return details.map((v) => {
    const code = v.payment_vendor_code || "";
    const ui = vendorUi(code, v.payment_vendor_name);
    return {
      id: v.map_id,
      map_id: v.map_id,
      payment_vendor_code: code,
      payment_vendor_name: v.payment_vendor_name || "",
      label: v.payment_vendor_name || code,
      subtitle: "Powered by NPCI UPI AutoPay",
      color: ui.color,
      abbr: vendorAbbr(code, v.payment_vendor_name) || ui.abbr,
      selBg: ui.selBg,
      selBorder: ui.selBorder,
    };
  });
}

export default function ProviderSelection({ onNext, onBack, api_token }) {
  const { state, update } = useMandate();
  const resolvedToken = api_token || localStorage.getItem("api_token");

  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(
    state.mapId != null ? state.mapId : null
  );

  useEffect(() => {
    const householdNumber = (state.householdNumber || "").trim();
    if (!householdNumber) {
      setProviders([]);
      setLoading(false);
      return;
    }

    if (state.paymentVendorDetails !== null && state.paymentVendorDetails !== undefined) {
      const resolved = resolvePaymentVendorDetails(
        state.paymentVendorDetails,
        state.searchedMembers
      );
      setProviders(mapPaymentVendors(resolved));
      setLoading(false);
      return;
    }

    setLoading(true);
    const queryParams = new URLSearchParams({ household_number: householdNumber }).toString();

    customFetch(
      process.env.REACT_APP_URL + "/upi/get/autopay/household/details?" + queryParams,
      { method: "GET", headers: { "api-token": resolvedToken } }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.api_code === 4) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        const hh = data && data[0];
        const details = resolvePaymentVendorDetails(
          Array.isArray(hh && hh.payment_vendor_details)
            ? hh.payment_vendor_details
            : [],
          state.searchedMembers
        );
        update({ paymentVendorDetails: details });
        setProviders(mapPaymentVendors(details));
      })
      .catch(() => setProviders([]))
      .finally(() => setLoading(false));
  }, [state.householdNumber, state.paymentVendorDetails, state.searchedMembers, resolvedToken]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleContinue() {
    if (selected == null) return;
    const prov = providers.find((p) => p.map_id === selected);
    update({
      provider: prov ? prov.payment_vendor_name : "",
      mapId: selected,
      payment_vendor_code: prov ? prov.payment_vendor_code : "",
      paymentVendorName: prov ? prov.payment_vendor_name : "",
      partnerName: prov ? prov.payment_vendor_name : "",
    });
    onNext();
  }

  const provLabel = selected != null
    ? (providers.find((p) => p.map_id === selected) || {}).label || ""
    : "";

  return (
    <section className="main-sec" style={{ minHeight: "100vh" }}>
      <div className="container fix-width">
      <AppBar title="Choose Provider" onBack={onBack} />
      <MemberStrip
        memberName={(state.selectedMember && state.selectedMember.memberName) || ""}
        partnerName={state.partnerName || state.paymentVendorName}
      />

      <div style={{ padding: "20px 0 20px" }}>

        {loading && (
          <div style={{ textAlign: "center", color: "#6b7280", fontSize: 13, padding: "24px 0" }}>
            Loading providers...
          </div>
        )}

        {!loading && providers.length === 0 && (
          <div style={{ textAlign: "center", color: "#6b7280", fontSize: 13, padding: "24px 0" }}>
            No autopay providers are available for this household.
          </div>
        )}

        {/* <div style={{ fontWeight: 700, fontSize: 13, color: "#374151", marginBottom: 10 }}>
          Select your preferred autopay method
        </div> */}

        {loading && (
          <div style={{ color: "#6b7280", fontSize: 13, marginBottom: 10 }}>
            Loading providers...
          </div>
        )}

        {!loading && !providers.length && (
          <div style={{ color: "#b91c1c", fontSize: 13, marginBottom: 10 }}>
            No active UPI providers found for this household.
          </div>
        )}
        {!loading && providers.map((p) => {
          const isSel = selected === p.map_id;
          return (
            <div
              key={p.map_id}
              onClick={() => setSelected(p.map_id)}
              style={{
                background: isSel ? p.selBg : "#fff",
                border: isSel ? `2px solid ${p.selBorder}` : "1px solid #e5e7eb",
                borderRadius: 16,
                padding: "12px 14px",
                marginBottom: 14,
                cursor: "pointer",
                position: "relative",
              }}
            >
              {isSel && (
                <div style={{
                  position: "absolute", top: 10, right: 10,
                  width: 14, height: 14, borderRadius: "50%", background: p.color,
                }} />
              )}
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: "50%", background: p.color,
                  color: "#fff", display: "flex", alignItems: "center",
                  justifyContent: "center", fontWeight: 700, fontSize: 13, flexShrink: 0,
                }}>
                  {p.payment_vendor_code || p.abbr}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{p.label} UPI Autopay</div>
                </div>
              </div>
            </div>
          );
        })}

        <button
          style={{
            background: selected != null ? BLUE : "#d1d5db",
            color: "#fff",
            borderRadius: 8,
            border: "none",
            cursor: selected != null ? "pointer" : "not-allowed",
            width: "100%",
            fontWeight: 700,
            marginBottom: 12,
            padding: "12px 0",
            fontSize: 15,
          }}
          disabled={selected == null || loading}
          onClick={handleContinue}
        >
          {selected != null ? `Continue with ${provLabel} UPI Autopay` : "Select a provider to continue"}
        </button>
      </div>

      </div>
    </section>
  );
}
